import styled from '@emotion/styled';

export const LoadMoreWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 30px 30px;
  flex-direction: column;
`;

export const LoadMoreText = styled.p`
  font-weight: 700;
  color: ${(props) => props.theme.color.medium.default};
  font-size: 14px;
  margin: 10px 0;
`;
